import { useReveal } from "../hooks/useReveal";

const STATS = [
    { v: "30+", k: "Countries served" },
    { v: "1,200+", k: "Partner farmers" },
    { v: "8,000 MT", k: "Annual capacity" },
    { v: "8 yrs", k: "Export experience" },
];

export default function About() {
    const ref = useReveal();
    const ref2 = useReveal();
    return (
        <section
            id="about"
            data-testid="about-section"
            className="bg-neutral-bg py-24 sm:py-32"
        >
            <div className="mx-auto max-w-7xl px-5 sm:px-8 lg:px-10">
                <div ref={ref} className="reveal grid gap-12 lg:grid-cols-12 lg:gap-20">
                    <div className="lg:col-span-7">
                        <span className="text-xs uppercase tracking-[0.22em] text-brand-red">
                            About RP Traders
                        </span>
                        <h2 className="mt-4 font-display text-4xl font-bold leading-[1.02] tracking-[-0.025em] sm:text-6xl">
                            Three generations of farming.
                            <br />
                            <span className="text-ink-muted">
                                One promise to the world.
                            </span>
                        </h2>
                    </div>
                    <div className="lg:col-span-5 lg:pt-3">
                        <p className="text-base leading-relaxed text-ink-muted sm:text-lg">
                            Founded in 2016 in the chilli capital of India,
                            Guntur, RP Traders is built on relationships
                            with farming families that span decades. We
                            grade, clean, and pack every consignment in
                            food-safe facilities — and ship under our IEC
                            and Spices Board registrations to importers,
                            blenders, and brands worldwide.
                        </p>
                        <p className="mt-5 text-base leading-relaxed text-ink-muted sm:text-lg">
                            From the Teja chillies of Andhra Pradesh to the
                            curcumin-rich turmeric of Erode and Nizamabad,
                            our goal is simple: deliver consistent, lab-tested
                            quality, on time, every time.
                        </p>
                    </div>
                </div>

                <div
                    ref={ref2}
                    data-testid="about-stats"
                    className="reveal mt-16 grid grid-cols-2 gap-px overflow-hidden rounded-3xl border border-hairline bg-hairline lg:grid-cols-4"
                >
                    {STATS.map((s) => (
                        <div
                            key={s.k}
                            className="bg-white p-8 transition-colors hover:bg-brand-turmeric/10"
                        >
                            <div className="font-display text-4xl font-bold tracking-[-0.02em] text-ink sm:text-5xl">
                                {s.v}
                            </div>
                            <div className="mt-2 text-sm text-ink-muted">
                                {s.k}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
